
import { DiaryEntry } from '../types';

const STORAGE_KEY = 'babyDiaryEntries';

export function getLocalEntries(): DiaryEntry[] {
  const entriesJson = localStorage.getItem(STORAGE_KEY);
  return entriesJson ? JSON.parse(entriesJson) : [];
}

export function saveLocalEntry(entry: DiaryEntry): void {
  const existingEntries = getLocalEntries();
  existingEntries.push(entry);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(existingEntries));
}

export function updateLocalEntry(updatedEntry: DiaryEntry): void {
  const entries = getLocalEntries();
  const entryIndex = entries.findIndex(entry => entry.id === updatedEntry.id);
  
  if (entryIndex !== -1) {
    const userId = entries[entryIndex].userId;
    entries[entryIndex] = { 
      ...updatedEntry,
      userId
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  }
}

export function getLocalUserEntries(userId: string): DiaryEntry[] {
  return getLocalEntries().filter(entry => entry.userId === userId);
}

export function findLocalEntryById(id: string): DiaryEntry | undefined {
  const entries = getLocalEntries();
  return entries.find(entry => entry.id === id);
}

export function deleteLocalEntry(id: string): void {
  const entries = getLocalEntries();
  const updatedEntries = entries.filter(entry => entry.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedEntries));
}

export function hasReachedLocalFreeLimit(userId: string): boolean {
  const localEntries = getLocalEntries();
  const userEntries = localEntries.filter(entry => 
    entry.userId === userId && !entry.isPremium
  );
  return userEntries.length >= 30;
}
